import axios from 'axios'
import store from '../store'
import { vm } from '../main'
const serverIp = 'll-livespeaking.liveabc.com/'
const appPath = 'api'
export const apiPath = 'https://' + serverIp + appPath
const api = axios.create({
  baseURL: apiPath,
  timeout: 60000 * 5,
  headers: {
    'access-control-allow-origin': '*',
    'Content-Type': 'application/json'
  }
})

api.interceptors.request.use(function (config) {
  config.headers.Authorization = 'Bearer ' + store.state.auth.user.token
  if (config.headers.showLoading !== false) {
    store.commit('isLoading', true)
  }

  return config
}, function (error) {
  return Promise.reject(error)
})

api.interceptors.response.use(function (response) {
  store.commit('isLoading', false)
  return response
}, function (error) {
  store.commit('isLoading', false)
  if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
    console.log('Request timed out')
  }
  if (error.response && error.response.status === 401) {
    store.commit('logout')
    vm.$router.push({ name: 'Login' })
    console.log(error.response)
  } else if (error.response.data) {
    store.commit('isLoading', false)
    console.log(error.response)
    // store.commit('setErrorMessage', error.response.data.Message)
    // console.log(error.response.statusText)
  } else {
    // store.commit('setErrorMessage', error.message)
  }
  return Promise.reject(error)
})

export default api
